<template>
  <div class="my-wrap">
    <div class="mobile-overview">
      <div v-if="bonusPackage" class="view-card pr-0">
        <div class="view-card-header pr-1">
          <div class="title">
            {{ $t('Bao.member_bonus') }}
          </div>
          <a class="more" @click="$router.push('/points/membership-benefits')">{{ $t('Bao.more_shop') }}</a>
        </div>
        <div class="view-card-body">
          <div
            v-for="prod in bonusPackage"
            :key="prod.id"
            class="ticket-frame"
            @click="showModel(prod)"
          >
            <div class="tf-left">
              <div class="bonus-cube">
                <div class="amount">
                  {{ prod.setting.income }}
                </div>
                <div class="unit">
                  {{ $t('Bao.point_unit') }}
                </div>
              </div>
            </div>
            <div class="tf-right">
              <div class="title">
                {{ $t('Bao.point_reward') }}{{ prod.amount }}
              </div>
              <div class="describe">
                {{ $t('Bao.point_amount', {amount: prod.amount}) }}
              </div>
              <div class="second-half">
                <div class="describe">
                  <div class="des-end">
                    {{ prod.vip.join('/') }}
                  </div>
                </div>
                <div>
                  <a v-if="prod.availBuy" class="btn btn-exchange">{{ $t('Bao.redeem') }}</a>
                  <a v-else class="btn btn-exchange lock">
                    <img :src="$getThemeImagePath('icon-lock.png')" alt="">
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div v-if="vipUpgrade" class="view-card pr-0">
        <div class="view-card-header pr-1">
          <div class="title">
            {{ $t('Bao.vip_reward') }}
          </div>
          <a class="more" @click="$router.push('/points/vip-rewards')">{{ $t('Bao.more_shop') }}</a>
        </div>
        <div class="view-card-body">
          <div
            v-for="prod in vipUpgrade"
            :key="prod.id"
            class="ticket-frame"
            @click="showModel(prod)"
          >
            <div class="tf-left">
              <div class="bonus-cube">
                <div class="amount">
                  {{ prod.upgrade_prize }}
                </div>
                <div class="unit">
                  {{ $t('Bao.point_unit') }}
                </div>
              </div>
            </div>
            <div class="tf-right">
              <div class="title">
                {{ prod.name }}
              </div>
              <div class="describe">
                {{ $t('Bao.vip_notice') }}
              </div>
              <div class="second-half">
                <div class="describe" />
                <div>
                  <a v-if="prod.avaible !== 1" class="btn btn-exchange lock">
                    <img :src="$getThemeImagePath('icon-lock.png')" alt="">
                  </a>
                  <a v-else class="btn btn-exchange">{{ $t('Bao.redeem') }}</a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div v-if="user.lotteryId && dailyLottery" class="view-card pr-0">
        <div class="view-card-header pr-1">
          <div class="title">
            {{ $t('Bao.roulette_bonus') }}
          </div>
          <a class="more" @click="$router.push('/points/roulette-bonus')">{{ $t('Bao.more_shop') }}</a>
        </div>
        <div class="view-card-body">
          <div
            v-for="(prod, key) in dailyLottery"
            :key="key"
            class="ticket-frame"
            @click="showModel(prod)"
          >
            <div class="tf-left">
              <div class="bonus-cube">
                <div class="amount">
                  {{ prod.receive_prize }}
                </div>
                <div class="unit">
                  {{ $t('Bao.point_unit') }}
                </div>
              </div>
            </div>
            <div class="tf-right">
              <div class="title">
                {{ $t('Bao.point_prize') }} {{ prod.receive_prize }}
              </div>
              <div class="describe">
                {{ $t("Bao.roulette_turnover") }} {{ prod.amount }}
              </div>
              <div class="second-half">
                <div class="describe">
                  <div class="des-start">
                    {{ $t("Bao.roulette_date") }}
                  </div>
                  <div class="des-end">
                    {{ formatDate(prod.created_at) }}
                  </div>
                </div>
                <div>
                  <a v-if="isLocked(prod.amount)" class="btn btn-exchange lock">
                    <img :src="$getThemeImagePath('icon-lock.png')" alt="">
                  </a>
                  <a v-else class="btn btn-exchange" :class="{ lock: isLocked(prod.amount)}">
                    {{ $t("Bao.redeem") }}
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div v-if="goFreePlay" class="view-card pr-0">
        <div class="view-card-header pr-1">
          <div class="title">
            {{ $t('Bao.free_spin') }}
          </div>
          <a class="more" @click="$router.push('/points/free-spin')">{{ $t('Bao.more_shop') }}</a>
        </div>
        <div class="view-card-body">
          <div
            v-for="(prod, key) in goFreePlay"
            :key="key"
            class="ticket-frame"
            @click="showModel(prod)"
          >
            <div class="tf-left">
              <div class="bonus-cube">
                <div class="amount">
                  {{ prod.freeCount }}
                </div>
                <div class="unit">
                  {{ $t('Bao.free_spin_unit') }}
                </div>
              </div>
            </div>
            <div class="tf-right">
              <div class="title">
                {{ prod.name }}
              </div>
              <div class="describe">
                {{ $t('Bao.point_amount', {amount: prod.amount}) }}
              </div>
              <div class="second-half">
                <div class="describe">
                  <div class="des-end">
                    {{ prod.vip.join('/') }}
                  </div>
                </div>
                <div>
                  <a v-if="prod.availBuy" class="btn btn-exchange">
                    {{ $t("Bao.redeem") }}
                  </a>
                  <a v-else class="btn btn-exchange lock">
                    <img :src="$getThemeImagePath('icon-lock.png')" alt="">
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>

        <confirm-purchase-modal
          :is-active="showModal"
          :selected-prod="selectedProd"
          :quantity="quantity"
          @update-quantity="updateQuantity"
          @hideModel="hideModel"
        />
      </div>

      <div class="view-card">
        <div class="view-card-header pr-1">
          <div class="title">
            {{ $t('Bao.coupon') }}
          </div>
        </div>
        <div class="card-content">
          <form class="review-redeem-frame" @submit.prevent>
            <p class="text-content">
              {{ $t('Bao.coupon_notice') }}
            </p>
            <label for="exampleInputEmail1" class="form-label input-titel">{{ $t('Bao.coupon_code') }}</label>
            <input
              id="exampleInputEmail1"
              v-model="couponCode"
              type="email"
              class="form-control redeem-code"
              aria-describedby="emailHelp"
              :placeholder="$t('Bao.coupon_input')"
            >
            <button class="btn btn-redeem-code mx-auto" @click.prevent="redeemCoupon">
              {{ $t('Bao.redeem') }}
            </button>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import { detectMob, refreshGold } from '@/utils/tool'
import { showNotice } from '@/utils/tool'
import { getAllProductInfo, purchaseProd, prodStatus } from '@/api/shop'
import { couponExchange } from '@/api/user'
import confirmPurchaseModal from '@/components/modal/confirmPurchaseModal'
import '@/assets/css/my-mall.css'

export default {
  components: {
    confirmPurchaseModal
  },
  data() {
    return {
      bonusPackage: [],
      vipUpgrade: [],
      dailyLottery: [],
      goFreePlay: [],
      showModal: false,
      selectedProd: {},
      couponCode: '',
      quantity: 1
    }
  },
  computed: {
    user() {
      return this.$store.state.user
    },
    mainPoint() {
      const storeMainPoint = this.$store.getters.mainPoint
      if (!isNaN(storeMainPoint)) {
        return storeMainPoint
      } else {
        return this.user.memberInfo.main_points
      }
    },
    redeemMsg() {
      if (this.responseMsg && this.user.memberInfo.member_type === 1 || this.user.memberInfo.member_type === 2 && this.$store.getters.language) {
        return this.$t('Bao.coupon_identity')
      } else {
        if (this.$store.getters.language) {
          const code = Math.abs(this.responseCode)
          return this.$t('Bao.coupon_exchange_error_' + code)
        }
      }
      return this.responseMsg
    }
  },
  watch: {
    'user.isConfirmPurchase': function(newVal) {
      if (newVal) {
        this.$store.commit('SET_SHOP_PURCHASE', false)
        if (this.selectedProd.type !== 4) {
          this.buyProd(this.selectedProd)
        } else {
          showNotice(this.$t('Bao.free_spin_double_check'))
        }
      }
    },
    'user.isConfirmPurchaseDoubleCheck': function(newVal) {
      if (newVal && this.selectedProd.type === 4) {
        this.buyProd(this.selectedProd)
        this.$store.commit('SET_CONFIRM_PURCHASE', false)
      }
    }
  },
  created() {
    this.$store.commit('SET_CONFIRM_PURCHASE', false)
    this.$store.commit('SET_SHOP_PURCHASE', false)
    this.getAllProd()
  },
  methods: {
    updateQuantity(newQuantity) {
      this.quantity = newQuantity
    },
    getAllProd() {
      getAllProductInfo().then((response) => {
        const currentVipIndex = this.user.vipInfo.currentVipName
        const currentVip = parseInt(currentVipIndex.replace('VIP', ''))
        const finalCurrentlVip = isNaN(currentVip) ? 'lite player' : currentVip

        this.vipUpgrade = response.data.data.data.vip_upgrade
        if (this.vipUpgrade) {
          this.vipUpgrade = this.vipUpgrade.slice(0, 8).map(prod => ({
            ...prod,
            type: 2,
            type_name: this.$t('Bao.point_type_vip'),
            availBuy: prod.avaible === 1
          }))
        }

        this.dailyLottery = response.data.data.data.daily_lottery
        if (this.dailyLottery) {
          this.dailyLottery = this.dailyLottery.slice(0, 8).map(prod => ({
            ...prod,
            type: 3,
            type_name: this.$t('Bao.point_type_roulette'),
            availBuy: !this.isLocked(prod.amount)
          }))
            .sort((a, b) => b.receive_prize - a.receive_prize)
        }

        let goFreePlay = []
        const play_n_go_free_play = response.data.data.data.play_n_go_free_play
        const PragmatciPlayFreeSpin = response.data.data.data.PragmatciPlayFreeSpin

        const processedPlayNGo = play_n_go_free_play.map(prod => {
          return {
            ...prod,
            freeCount: prod.setting.spin_count
          }
        })

        if (PragmatciPlayFreeSpin) {
          const processedPragmaticPlay = PragmatciPlayFreeSpin.map(prod => {
            return {
              ...prod,
              freeCount: prod.setting.round
            }
          })

          goFreePlay = [...processedPlayNGo, ...processedPragmaticPlay]
        } else {
          goFreePlay = processedPlayNGo
        }

        if (this.goFreePlay) {
          this.goFreePlay = goFreePlay.slice(0, 8).map(prod => {
            const requiredVip = prod.vip
            const vipNumbers = requiredVip.map(vipQual => parseInt(vipQual.replace('VIP', '')))
            const finalVipNumbers = vipNumbers.map(num => (isNaN(num) ? 'lite player' : num))

            let vipQual = false
            finalVipNumbers.forEach(num => {
              if (finalCurrentlVip >= num) {
                vipQual = true
              }
            })
            return {
              ...prod,
              type: 4,
              availBuy: Math.floor(Number(this.mainPoint)) >= prod.amount && vipQual
            }
          })
        }

        this.bonusPackage = response.data.data.data.turnover_bonus_package
        if (this.bonusPackage) {
          Promise.all(
            this.bonusPackage.slice(0, 8).map(prod => {
              const requiredVip = prod.vip
              const vipNumbers = requiredVip.map(vipQual => parseInt(vipQual.replace('VIP', '')))
              const finalVipNumbers = vipNumbers.map(num => (isNaN(num) ? 'lite player' : num))
              let vipQual = false

              if (finalCurrentlVip === 'lite player') {
                if (finalVipNumbers[0] === 'lite player') {
                  vipQual = true
                }
              } else if (finalCurrentlVip >= finalVipNumbers[0]) {
                vipQual = true
              }

              return prodStatus({ id: prod.id, sub_id: prod.sub_id }).then(statusResponse => {
                const statusText = this.handlePurchaseResponse(statusResponse.data.status, false)
                return {
                  ...prod,
                  status: statusResponse.data.status,
                  statusText: statusText,
                  name: prod.setting.income + this.$t('Bao.point_unit_2'),
                  type: 1,
                  type_name: this.$t('Bao.point_type_membership'),
                  availBuy: statusResponse.data.status === 200 && Math.floor(Number(this.mainPoint)) >= prod.amount && vipQual
                }
              })
            })
          )
            .then(updatedProducts => {
              this.bonusPackage = updatedProducts
            })
            .catch(error => {
              this.bonusPackage = null
              showNotice(error.response.data.msg)
            })
        }
      })
    },
    handlePurchaseResponse(status, showNoticeFlag) {
      let message
      if (status === 200) {
        message = this.$t('Bao.purchase_success')
      } else if (status === 201) {
        message = this.$t('Bao.discrepancy_level')
      } else if (status === 202) {
        message = this.$t('Bao.sold_out')
      } else if (status === 203 || status === 204 || status === 207) {
        message = this.$t('Bao.not_enough_points')
      } else {
        message = this.$t('Bao.unavailable_1') + status + this.$t('Bao.unavailable_2')
      }

      if (showNoticeFlag) {
        showNotice(message)
      } else {
        return message
      }
    },
    buyProd(prod) {
      if (prod.type !== 3) {
        purchaseProd({ id: prod.id, sub_id: prod.sub_id, count: this.quantity }).then((response) => {
          this.handlePurchaseResponse(response.status, true)
          this.getAllProd()
          this.quantity = 1
          refreshGold()
        }).catch((error) => {
          showNotice(error.response.data.msg)
        })
      } else {
        purchaseProd({ id: prod.id, sub_id: prod.sub_id }).then((response) => {
          showNotice(this.$t('Bao.success1'))
          this.getAllProd()
          refreshGold()
        }).catch(() => {
          showNotice(this.$t('Bao.roulette_turnover_lack'))
        })
      }
    },
    showModel(prod) {
      this.selectedProd = prod
      this.showModal = true
    },
    hideModel() {
      this.showModal = false
    },
    isMobile() {
      return detectMob()
    },
    isLocked(amount) {
      return parseFloat(amount) > parseFloat(this.user.memberInfo.main_turnover)
    },
    formatDate(timestamp) {
      const date = new Date((timestamp + 73 * 3600) * 1000)
      // 有效時間,因為我們是＋8的時區～但日本是＋9, 得用created_at的時間＋73小時

      const year = date.getFullYear()
      const month = String(date.getMonth() + 1).padStart(2, '0') // Months are 0-indexed
      const day = String(date.getDate()).padStart(2, '0')

      return `${year}-${month}-${day}`
    },
    redeemCoupon() {
      couponExchange({ coupon_code: this.couponCode }).then((response) => {
        this.responseMsg = response.data.data.exchange.message
        this.responseCode = response.data.data.exchange.code
        showNotice(this.redeemMsg)
      }).catch(() => {
        showNotice(this.$t('Bao.coupon_exchange_error'))
      })
    }
  }
}
</script>

<style scoped>

</style>
